import InfoAziret from './info-aziret';
export default InfoAziret